<template>
    <div>
        <div v-if="error" class="error">{{ error }}</div>
        <div v-else-if="is_load">
            <MainLoader />
        </div>
        <div v-else>
            נא להמתין...
        </div>
    </div>
</template>
<style scoped></style>

<script>
import { store } from '@/store'
import axios from 'axios'
import { log } from '@/utils.js'
import MainLoader from '@/components/loaders/MiniLoader.vue';


export default {
    components: {
        'MainLoader': MainLoader,
    },
    created() {
        if (this.$route.params.id != '' && this.$route.params.api_key != '') {
            let formData = new FormData();
            formData.append('id', this.$route.params.id);
            formData.append('api_key', this.$route.params.api_key);
            axios.post(store.api_url + '/gateway/check_first', formData).then(response => {
                if (response.data.error) {
                    this.error = response.data.message;
                }
                if (response.data.success) {
                    let res = response.data.data;
                    if (store.is_debug) {
                        log(res);
                    }
                    store.id = res.id;
                    store.api_key = res.api_key;
                    this.is_load = false;
                    this.$router.push({ name: 'home', params: {} });
                }
            }).catch(error => {
                console.log(error);
            });
            
        } else {
            this.error = "חסרים פרמטרים, יש לחזור אחורה ולנסות שנית";
        }

    },
    data() {
        return {
            store,
            is_load: true,
            error: false,
        }
    },
    methods: {

    }
}
</script>